// import Header from "components/ui/Header";
import Footer from "components/ui/Footer";
import { Outlet } from "react-router-dom";
import EnumeratorHeader from "./components/EnumeratorHeader";
import "./styles.css";
import React, { useEffect, useState } from "react";
import { Alert, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { auth } from "../../firebase/firebase";
import { getAuth, sendEmailVerification } from "firebase/auth";
import { useUserVerification } from "api/register/useConfirmVerification";
import { useMutation } from "@tanstack/react-query";
import { notification } from 'antd';

const useResendVerificationEmail = () => {
  return useMutation({
    mutationFn: async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        throw new Error("No authenticated user found.");
      }
      await sendEmailVerification(user);
    },
  });
};

const DisplayAlert: React.FC = () => {
  const [isEmailVerified, setIsEmailVerified] = useState<boolean | null>(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false);
  const [showErrorAlert, setShowErrorAlert] = useState<boolean>(false);
  const [showExpiredAlert, setShowExpiredAlert] = useState<boolean>(false);
  const [verificationChecked, setVerificationChecked] = useState<boolean>(false);
  const { mutate: verifyUser } = useUserVerification();
  const { mutate: resendVerificationEmail } = useResendVerificationEmail();

  useEffect(() => {
    const checkVerificationStatus = async () => {
      verifyUser(undefined, {
        onSuccess: (data) => {
          if (data.status === "verified" || data.status === "first_verify") {
            setIsEmailVerified(true);
            setShowErrorAlert(false);
            setShowExpiredAlert(false);
            if (!localStorage.getItem("successAlertClosed")) {
              setShowSuccessAlert(true);
            }
          } else if (data.status === "not_verified") {
            setIsEmailVerified(false);
            setShowSuccessAlert(false);
            setShowErrorAlert(true);
            setShowExpiredAlert(false);
          }
          else if (data.status === "expired") {
            setIsEmailVerified(false);
            setShowSuccessAlert(false);
            setShowErrorAlert(false);
            setShowExpiredAlert(true);
          }
          setVerificationChecked(true);
        },
        onError: () => {
          setIsEmailVerified(false);
          setShowSuccessAlert(false);
          setShowErrorAlert(true);
          setVerificationChecked(true);
          setShowExpiredAlert(false);
        },
      });
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        checkVerificationStatus();
      }
    });

    return () => unsubscribe();
  }, [verifyUser]);

  const handleAlertClose = (type: "success" | "error" | "expired") => {
    if (type === "success") {
      setShowSuccessAlert(false);
      localStorage.setItem("successAlertClosed", "true");
    } else if (type === "error") {
      setShowErrorAlert(false);
    } else if (type === "expired") {
      setShowExpiredAlert(false);
    }
  };

  const handleResendVerificationEmail = () => {
    resendVerificationEmail(undefined, {
      onSuccess: () => {
        setShowExpiredAlert(false);
        setShowSuccessAlert(false);
        setShowErrorAlert(false);
        notification.success({
          message: 'Verification Email Sent',
          description: 'A new verification link has been sent to your email.',
        });
      },
      onError: () => {
        setShowExpiredAlert(true);}
    });
  };

  useEffect(() => {
    const successAlertClosed = localStorage.getItem("successAlertClosed");
    if (successAlertClosed === "true") {
      setShowSuccessAlert(false);
    }
  }, []);

  return (
    <div className="min-w-full max-w-full w-full  " >
        <>
          {verificationChecked && isEmailVerified && showSuccessAlert && (
            <Alert
              message="Email Verified"
              description="Your email has been successfully verified."
              type="success"
              className="w-full h-26"
              showIcon
              closable
              closeIcon={<CloseOutlined />}
              onClose={() => handleAlertClose("success")}
            />
          )}

          {verificationChecked && !isEmailVerified && showErrorAlert && (
            <Alert
              message="Email Not Verified"
              description="You have not verified your email yet. Please check your inbox."
              type="info"
              className="w-full h-26"
              showIcon
              closable
              closeIcon={<CloseOutlined />}
              onClose={() => handleAlertClose("error")}
            />
          )}
           {verificationChecked && !isEmailVerified && showExpiredAlert && (
          <Alert
            message="Verification Link Expired"
            description={
              <>
                Your verification link has expired. Please request a new link.
                <div className="mt-2 self-end pe-5">
                  <Button type="primary" onClick={handleResendVerificationEmail}>
                    Resend Verification Link
                  </Button>
                </div>
              </>
            }
            type="warning"
            className="w-full h-26"
            showIcon
            closable
            closeIcon={<CloseOutlined />}
            onClose={() => handleAlertClose("expired")}
          />
        )}

        </>
      </div>
  );
}

function EnumeratorLayout() {
  return (
    <>
      <EnumeratorHeader />
      <DisplayAlert/>

      <div id="content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default EnumeratorLayout;
